module.exports = __webpack_public_path__ + "img/threeStripes.f8a83d48.svg";